import Vue from "vue";
import Router from "vue-router";

// Containers
const DefaultContainer = () => import("@/containers/DefaultContainer");

// Views
const Dashboard = () => import("@/views/Dashboard");

// Views - Login
const Login = () => import("@/views/login/Login");
const Changepassword = () => import("@/views/users/Changepassword");

// Views - Users
const User = () => import("@/views/users/UsersIndex");
const UserPassword = () => import("@/views/users/UserPassword");

// Views - RateInterests
const RateInterestList = () => import("@/views/rateInterest/RateInterestList");
const RateInterestAdd = () => import("@/views/rateInterest/RateInterestAdd");
const RateInterestEdit = () => import("@/views/rateInterest/RateInterestEdit");

// Views - Option
const OptionList = () => import("@/views/options/OptionList");
const OptionAdd = () => import("@/views/options/OptionAdd");
const OptionEdit = () => import("@/views/options/OptionEdit");

// Views - Role
const RoleList = () => import("@/views/roles/RoleList");
const RoleAdd = () => import("@/views/roles/RoleAdd");
const RoleEdit = () => import("@/views/roles/RoleEdit");

// Views - Staf
const StaffList = () => import("@/views/staffs/StaffList");
const StaffAdd = () => import("@/views/staffs/StaffAdd");
const StaffEdit = () => import("@/views/staffs/StaffEdit");

// Views - Customers
const CustomerList = () => import("@/views/customers/CustomerList");
const CustomerAdd = () => import("@/views/customers/CustomerAdd");
const CustomerEdit = () => import("@/views/customers/CustomerEdit");
const CustomerView = () => import("@/views/customers/CustomerView");
const CustomerIndicators = () => import("@/views/customers/CustomerIndicators");

// Views - Debtors
const DebtorList = () => import("@/views/debtors/DebtorList");
const DebtorAdd = () => import("@/views/debtors/DebtorAdd");
const DebtorEdit = () => import("@/views/debtors/DebtorEdit");
const DebtorView = () => import("@/views/debtors/DebtorView");

const ReportView = () => import("@/views/report/Generic");
const TaskView = () => import("@/views/task/Task");
const Birthdaycontact = () => import("@/views/birthday/Birthdaycontact");
const ManagementAnalysis = () => import("@/views/task/ManagementAnalysis");
const PaymentsAnalysis = () =>  import("@/views/indicators/prejury/PaymentsAnalysis");
const DebtorManagementAnalysis = () => import("@/views/indicators/prejury/DebtorManagementAnalysis");
const WalletIndicators = () => import("@/views/indicators/commercial/WalletIndicators");
const PaymentHistory = () => import("@/views/indicators/prejury/PaymentHistory");
const ManagementCount = () => import("@/views/indicators/prejury/ManagementCount");
const AnalysisTypifications = () => import("@/views/indicators/prejury/AnalysisTypifications");
const AnalysisWalletAge = () => import("@/views/indicators/prejury/AnalysisWalletAge");
const AnalysisSegmentPayments = () => import("@/views/indicators/prejury/AnalysisSegmentPayments");
const AnalysisSegmentPaymentsTotals = () => import("@/views/indicators/prejury/AnalysisSegmentPaymentsTotals");
const AnalysisBalancesRecover = () => import("@/views/indicators/prejury/AnalysisBalancesRecover");

const PrejuryCustomerPaymentsAnalysis = () => import("@/views/indicators/prejury/PrejuryCustomerPaymentsAnalysis");
const ExportPrejury = () => import("@/views/exports/ExportPrejury");

const AnalysisPaymentsCustomers = () => import("@/views/indicators/prejury/AnalysisPaymentsCustomers");
const SummaryPaymentsCustomer = () => import("@/views/indicators/prejury/SummaryPaymentsCustomer");

// PARA EL CLIENTE
const CustomerPaymentsAnalysis = () => import("@/views/indicators/prejury/CustomerPaymentsAnalysis");

// INDICADORES PARA EL COMERCIAL
const MonthlySummary = () => import("@/views/indicators/commercial/MonthlySummary");
const CustomerBehavior = () => import("@/views/indicators/commercial/CustomerBehavior");
const CurrentWalletStatus = () => import("@/views/indicators/commercial/CurrentWalletStatus");
const VolumeTasks = () => import("@/views/indicators/commercial/VolumeTasks");
const BranchOffice = () => import("@/views/branchOffices/index");

// Views - Currency
const Currency = () => import("@/views/currency/CurrencyIndex");
const Mainletter = () => import("@/views/letters/MainLetter");

// Views - Judged
const Judged = () => import("@/views/judgeds/Judgeds");

const Page404 = () => import("@/views/pages/Page404");
const Page500 = () => import("@/views/pages/Page500");
const Informes = () => window.location.href = "http://informes.treboljuridico.com/abonos";
const Correos = () => window.location.href = "http://informes.treboljuridico.com/cartas";
const sms = () => window.location.href = "http://informes.treboljuridico.com/lettersms";


Vue.use(Router);

export default new Router({
  mode: "hash", // https://router.vuejs.org/api/#mode
  linkActiveClass: "open active",
  scrollBehavior: () => ({ y: 0 }),
  routes: [
    {
      path: "/",
      redirect: "dashboard",
      name: "Inicio",
      component: DefaultContainer,
      children: [
        {
          path: "dashboard",
          name: "Dashboard",
          component: Dashboard
        },
        // -------------------------------------------------
        // URL´S PARA EL USUARIO
        // -------------------------------------------------
        {
          path: "users",
          meta: { label: "Usuarios" },
          component: {
            render(c) {
              return c("router-view");
            }
          },
          children: [
            {
              path: "",
              component: User
            }
          ]
        },
        // -------------------------------------------------
        // URL´S PARA LAS SUCURSALES Mainletter
        // -------------------------------------------------
        {
          path: "branchoffices",
          meta: { label: "Sucursales" },
          component: {
            render(c) {
              return c("router-view");
            }
          },
          children: [
            {
              path: "",
              component: BranchOffice
            }
          ]
        },
        // -------------------------------------------------
        // URL´S PARA LAS MONEDAS
        // -------------------------------------------------
        {
          path: "currencies",
          meta: { label: "Divisas" },
          component: {
            render(c) {
              return c("router-view");
            }
          },
          children: [
            {
              path: "",
              component: Currency
            }
          ]
        },

        // -------------------------------------------------
        // URL´S PARA LOS JUZGADOS
        // -------------------------------------------------
        {
          path: "judgeds",
          meta: { label: "Juzgados" },
          component: {
            render(c) {
              return c("router-view");
            }
          },
          children: [
            {
              path: "",
              component: Judged
            }
          ]
        },
        // -------------------------------------------------
        // URL´S PARA LA TASA DE INTERÉS
        // -------------------------------------------------
        {
          path: "rateInterests",
          meta: { label: "Tasa de Interés" },
          component: {
            render(c) {
              return c("router-view");
            }
          },
          children: [
            {
              path: "",
              component: RateInterestList
            },
            {
              path: "add",
              meta: { label: "Crear Tasa Interés" },
              name: "rateInterestAdd",
              component: RateInterestAdd
            },
            {
              path: "edit/:id",
              meta: { label: "Editar Tasa Interés" },
              name: "rateInterestEdit",
              component: RateInterestEdit
            }
          ]
        },

        // -------------------------------------------------
        // URL´S PARA LAS CARTAS
        // -------------------------------------------------
        {
          path: "mainletter",
          meta: { label: "Cartas" },
          component: {
            render(c) {
              return c("router-view");
            }
          },
          children: [
            {
              path: "",
              component: Mainletter
            }
          ]
        },
        {
          path: "informes",
          meta: { label: "informes" },
          component: {

          },
          children: [
            {
              path: "",
              component: Informes
            }
          ]
        },
        {
          path: "CORREOS",
          meta: { label: "CORREOS" },
          component: {

          },
          children: [
            {
              path: "",
              component: Correos
            }
          ]
        },
        {
          path: "SMS",
          meta: { label: "SMS" },
          component: {

          },
          children: [
            {
              path: "",
              component: sms
            }
          ]
        },
        
        // -------------------------------------------------
        // URL´S PARA EL USUARIO
        // -------------------------------------------------
        {
          path: "password",
          meta: { label: "Cambiar contraseña" },
          component: {
            render(c) {
              return c("router-view");
            }
          },
          children: [
            {
              path: "",
              component: UserPassword
            }
          ]
        },
        // -------------------------------------------------
        // URL´S PARA LAS OPCIONES DEL SISTEMA
        // -------------------------------------------------
        {
          path: "options",
          meta: { label: "Opciones del Sistema" },
          component: {
            render(c) {
              return c("router-view");
            }
          },
          children: [
            {
              path: "",
              component: OptionList
            },
            {
              path: "add",
              meta: { label: "Crear Opción" },
              name: "optionAdd",
              component: OptionAdd
            },
            {
              path: "edit/:id",
              meta: { label: "Editar Opción" },
              name: "optionEdit",
              component: OptionEdit
            }
          ]
        },

        // -------------------------------------------------
        // URL´S PARA LOS ROLES DEL SISTEMA
        // -------------------------------------------------
        {
          path: "roles",
          meta: { label: "Roles del Sistema" },
          component: {
            render(c) {
              return c("router-view");
            }
          },
          children: [
            {
              path: "",
              component: RoleList
            },
            {
              path: "add",
              meta: { label: "Crear Rol" },
              name: "roleAdd",
              component: RoleAdd
            },
            {
              path: "edit/:id",
              meta: { label: "Editar Rol" },
              name: "roleEdit",
              component: RoleEdit
            }
          ]
        },

        // -------------------------------------------------
        // URL´S PARA LOS FUNCIONARIOS DEL SISTEMA
        // -------------------------------------------------
        {
          path: "staffs",
          meta: { label: "Funcionarios" },
          component: {
            render(c) {
              return c("router-view");
            }
          },
          children: [
            {
              path: "",
              component: StaffList
            },
            {
              path: "add",
              meta: { label: "Crear Funcionario" },
              name: "staffAdd",
              component: StaffAdd
            },
            {
              path: "edit/:id",
              meta: { label: "Editar Funcionario" },
              name: "stafEdit",
              component: StaffEdit
            }
          ]
        },

        // -------------------------------------------------
        // URL´S PARA EL CLIENTE
        // -------------------------------------------------
        {
          path: "customers",
          meta: { label: "Cuentas" },
          component: {
            render(c) {
              return c("router-view");
            }
          },
          children: [
            {
              path: "",
              component: CustomerList
            },
            {
              path: "add",
              meta: { label: "Crear Cliente" },
              name: "customerAdd",
              component: CustomerAdd
            },
            {
              path: "edit/:id",
              meta: { label: "Editar Cliente" },
              name: "customerEdit",
              component: CustomerEdit
            },
            {
              path: "view/:id",
              meta: { label: "Gestión Cliente" },
              name: "customerView",
              component: CustomerView
            }
          ]
        },

        // -------------------------------------------------
        // URL´S PARA EL DEUDOR
        // -------------------------------------------------
        {
          path: "debtors",
          meta: { label: "Deudores" },
          component: {
            render(c) {
              return c("router-view");
            }
          },
          children: [
            {
              path: "",
              component: DebtorList
            },
            {
              path: "add",
              meta: { label: "Crear Deudor" },
              name: "debtorAdd",
              component: DebtorAdd
            },
            {
              path: "edit/:id",
              meta: { label: "Editar Deudor" },
              name: "debtorEdit",
              component: DebtorEdit
            },
            {
              path: "view/:id",
              meta: { label: "Gestión Deudor" },
              name: "debtorView",
              component: DebtorView
            }
          ]
        },

        // -------------------------------------------------
        // URL´S PARA EL CLIENTE
        // -------------------------------------------------
        {
          path: "debtorindicators",
          meta: { label: "Análisis cartera cliente" },
          component: {
            render(c) {
              return c("router-view");
            }
          },
          children: [
            {
              path: "",
              component: CustomerPaymentsAnalysis
            }
          ]
        },
        // REPORTE PARA EL PREJURIDICO -
        {
          path: "debtor/prejurycustumerindicators",
          meta: { label: "Cartera por cliente" },
          component: {
            render(c) {
              return c("router-view");
            }
          },
          children: [
            {
              path: "",
              component: PrejuryCustomerPaymentsAnalysis
            }
          ]
        },
        // REPORTE PARA EL COMERCIAL -
        {
          path: "prejurycustumerindicators",
          meta: { label: "Cartera por cliente" },
          component: {
            render(c) {
              return c("router-view");
            }
          },
          children: [
            {
              path: "",
              component: PrejuryCustomerPaymentsAnalysis
            }
          ]
        },

        // -------------------------------------------------
        // URL´S PARA REPORTES
        // -------------------------------------------------
        {
          path: "reports",
          meta: { label: "Reportes" },
          component: {
            render(c) {
              return c("router-view");
            }
          },
          children: [
            {
              path: "",
              component: ReportView
            }
          ]
        },
        {
          path: "tasks",
          meta: { label: "Tareas" },
          component: {
            render(c) {
              return c("router-view");
            }
          },
          children: [
            {
              path: "",
              component: TaskView
            }
          ]
        },
        {
          path: "export/prejury",
          meta: { label: "Exportación prejuridica" },
          component: {
            render(c) {
              return c("router-view");
            }
          },
          children: [
            {
              path: "",
              component: ExportPrejury
            }
          ]
        },
        {
          path: "indicators",
          meta: { label: "Indicadores" },
          component: {
            render(c) {
              return c("router-view");
            }
          },
          children: [
            {
              path: "",
              component: CustomerIndicators
            }
          ]
        },

        {
          path: "managementanalysis",
          meta: { label: "Análisis gestión" },
          component: {
            render(c) {
              return c("router-view");
            }
          },
          children: [
            {
              path: "",
              component: ManagementAnalysis
            }
          ]
        },

        {
          path: "birthday",
          meta: { label: "Cumpleaños" },
          component: {
            render(c) {
              return c("router-view");
            }
          },
          children: [
            {
              path: "",
              component: Birthdaycontact
            }
          ]
        },
        {
          path: "debtor/indicators",
          meta: { label: "Análisis abonos" },
          component: {
            render(c) {
              return c("router-view");
            }
          },
          children: [
            {
              path: "",
              component: PaymentsAnalysis
            }
          ]
        },
        {
          path: "debtor/managementanalysis",
          meta: { label: "Análisis gestión" },
          component: {
            render(c) {
              return c("router-view");
            }
          },
          children: [
            {
              path: "",
              component: DebtorManagementAnalysis
            }
          ]
        },
        {
          path: "debtor/paymenthistory",
          meta: { label: "Historial de abonos" },
          component: {
            render(c) {
              return c("router-view");
            }
          },
          children: [
            {
              path: "",
              component: PaymentHistory
            }
          ]
        },
        {
          path: "debtor/managementcount",
          meta: { label: "Conteo de gestiones" },
          component: {
            render(c) {
              return c("router-view");
            }
          },
          children: [
            {
              path: "",
              component: ManagementCount
            }
          ]
        },
        {
          path: "debtor/analysistypifications",
          meta: { label: "Análisis por tipificaciones" },
          component: {
            render(c) {
              return c("router-view");
            }
          },
          children: [
            {
              path: "",
              component: AnalysisTypifications
            }
          ]
        },
        {
          path: "debtor/analysiswalletage",
          meta: { label: "Análisis por edad de la cartera" },
          component: {
            render(c) {
              return c("router-view");
            }
          },
          children: [
            {
              path: "",
              component: AnalysisWalletAge
            }
          ]
        },
        {
          path: "debtor/analysissegmentpayments",
          meta: { label: "Análisis de abonos por segmentos" },
          component: {
            render(c) {
              return c("router-view");
            }
          },
          children: [
            {
              path: "",
              component: AnalysisSegmentPayments
            }
          ]
        },
        {
          path: "debtor/analysissegmentpaymentstotals",
          meta: { label: "Análisis de abonos por segmentos (Totales)" },
          component: {
            render(c) {
              return c("router-view");
            }
          },
          children: [
            {
              path: "",
              component: AnalysisSegmentPaymentsTotals
            }
          ]
        },
        {
          path: "debtor/analysisbalancesrecover",
          meta: { label: "Abonos posibles según segmentos" },
          component: {
            render(c) {
              return c("router-view");
            }
          },
          children: [
            {
              path: "",
              component: AnalysisBalancesRecover
            }
          ]
        },
        {
          path: "debtor/analysispaymentscustomers",
          meta: { label: "Análisis de abonos por clientes" },
          component: {
            render(c) {
              return c("router-view");
            }
          },
          children: [
            {
              path: "",
              component: AnalysisPaymentsCustomers
            }
          ]
        },
        {
          path: "debtor/summarypaymentscustomer",
          meta: { label: "Resumen cartera por cliente" },
          component: {
            render(c) {
              return c("router-view");
            }
          },
          children: [
            {
              path: "",
              component: SummaryPaymentsCustomer
            }
          ]
        },

        {
          path: "walletindicators",
          meta: { label: "Análisis abonos" },
          component: {
            render(c) {
              return c("router-view");
            }
          },
          children: [
            {
              path: "",
              component: WalletIndicators
            }
          ]
        },
        {
          path: "monthlysummary",
          meta: { label: "Resumen mensual" },
          component: {
            render(c) {
              return c("router-view");
            }
          },
          children: [
            {
              path: "",
              component: MonthlySummary
            }
          ]
        },
        {
          path: "customerbehavior",
          meta: { label: "Comportamiento de clientes" },
          component: {
            render(c) {
              return c("router-view");
            }
          },
          children: [
            {
              path: "",
              component: CustomerBehavior
            }
          ]
        },
        {
          path: "currentwalletstatus",
          meta: { label: "Estado actual de la cartera" },
          component: {
            render(c) {
              return c("router-view");
            }
          },
          children: [
            {
              path: "",
              component: CurrentWalletStatus
            }
          ]
        },
        {
          path: "volumetasks",
          meta: { label: "Volumen de tareas" },
          component: {
            render(c) {
              return c("router-view");
            }
          },
          children: [
            {
              path: "",
              component: VolumeTasks
            }
          ]
        }
      ]
    },
    {
      path: "",
      name: "Pages",
      component: {
        render(c) {
          return c("router-view");
        }
      },
      children: [
        {
          path: "/login",
          name: "Login",
          component: Login
        },
        {
          // Vista para cambiar la contraseña sin loguearse
          path: "/changepassword",
          name: "Changepassword",
          component: Changepassword
        },
        {
          path: "404",
          name: "Page404",
          component: Page404
        },
        {
          path: "500",
          name: "Page500",
          component: Page500
        }
      ]
    }
  ]
});
